import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { formatInr } from "../lib/usePricingCatalog";

export const AdminPricingTable = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let active = true;
    api.get("/admin/pricing").then(({ data: result }) => { if (active) setData(result); }).catch(() => {});
    return () => { active = false; };
  }, []);
  if (!data) return null;
  return (
    <section className="border border-zinc-800 bg-zinc-900/40 text-zinc-100 p-5 mt-6" data-testid="admin-pricing-config">
      <h2 className="font-semibold text-lg mb-3">Current pricing</h2>
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left">
          <thead className="font-mono text-xs text-zinc-500"><tr><th>Plan</th><th>Price</th><th>Minutes</th><th>₹/minute</th><th>Validity</th></tr></thead>
          <tbody>{data.plans.map((p) => <tr key={p.key} className="border-t border-zinc-800" data-testid={`admin-pricing-${p.key}`}>
            <td className="py-3" data-testid={`admin-plan-name-${p.key}`}>{p.name}</td>
            <td data-testid={`admin-plan-price-${p.key}`}>₹{formatInr(p.amount_inr)}</td>
            <td data-testid={`admin-plan-minutes-${p.key}`}>{p.minutes}{p.allowance_type === "one_time" ? " once" : ""}</td>
            <td data-testid={`admin-plan-rate-${p.key}`}>{p.amount_inr ? `₹${p.per_minute_inr.toFixed(2)}` : "—"}</td>
            <td data-testid={`admin-plan-validity-${p.key}`}>{p.duration_days ? `${p.duration_days} days` : "No renewal"}</td>
          </tr>)}</tbody>
        </table>
      </div>
      <p className="text-xs text-zinc-500 mt-3" data-testid="admin-pricing-economics">
        Internal estimated processing cost: ₹{data.estimated_processing_cost_inr_per_minute.toFixed(2)}/minute.
        Referrer reward: {data.referral_discount_percent}% after {data.referrals_per_reward} valid signups. No stacking.
        Actual costs and historical paid amounts remain separate from this catalogue.
      </p>
    </section>
  );
};
